import styles from "./AvtaleVilkaar.module.less";
import { Heading } from "@digipost/dds-heading-react";
import Translated from "../../infrastructure/translation/Translated";
import { Checkbox } from "@digipost/dds-checkbox-react";
import {
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
} from "@digipost/dds-buttons-react";
import { useState } from "react";
import { BedriftskundeInfo } from "../../InfoPage/BedriftskundeInfo";
import { InputWrapperWithErrorMessage } from "../../InputWrapperWithErrorMessage/InputWrapperWithErrorMessage";
import { useRegistreringContext } from "../../Registreringsflyt/useRegistreringContext";

export function AvtaleVilkaar() {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showError, setShowError] = useState(false);

  const { integrasjonsPartner, nextStep, previousStep, reset } =
    useRegistreringContext();

  if (!integrasjonsPartner) {
    return reset();
  }

  const accept = () => {
    if (!acceptedTerms) {
      setShowError(true);
    } else {
      nextStep();
    }
  };

  const partnerName = integrasjonsPartner.orgName;

  return (
    <section>
      <Heading level={1} size={"large"}>
        <Translated textKey={"partneronboarding.avtalevilkaar.title"} />
      </Heading>
      <p>
        <Translated
          textKey={"partneronboarding.avtalevilkaar.info.one"}
          params={{ partnerName }}
        />
      </p>
      <p>
        <Translated
          textKey={"partneronboarding.avtalevilkaar.info.two"}
          params={{ partnerName }}
        />
      </p>
      <p>
        <Translated
          textKey={"partneronboarding.avtalevilkaar.info.three"}
          params={{ partnerName }}
        />
      </p>

      <InputWrapperWithErrorMessage
        showError={showError}
        errorTextKey="summary.accept_terms_warning"
        InputComponent={
          <Checkbox
            name={"acceptTerms"}
            value={"acceptTerms"}
            checked={acceptedTerms}
            onChange={(e) => {
              setShowError(false);
              setAcceptedTerms(e.target.checked);
            }}
          >
            <Translated
              allowHtml
              textKey={"partneronboarding.avtalevilkaar.accept_terms"}
            />
          </Checkbox>
        }
      />

      <ButtonGroup className={styles.nesteOgTilbakeKnapp}>
        <SecondaryButton type="button" onClick={previousStep}>
          <Translated textKey={"generic.back"} />
        </SecondaryButton>
        <PrimaryButton onClick={accept}>
          <Translated textKey={"generic.next"} />
        </PrimaryButton>
      </ButtonGroup>
      <BedriftskundeInfo />
    </section>
  );
}
